module.exports = __webpack_public_path__ + "img/icon-menu-user-inv.79bb1b41.png";